import React from 'react';
import './FoundersSection.css';

const FoundersSection: React.FC = () => {
  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
  };

  return (
    <section className="founders-section" data-section="founders">
      <div className="container">
        <div className="founders-welcome">
          <h2>Willkommen in der <span className="highlight-text">MINTkitchen</span></h2>
          <p>Wir kombinieren didaktische und technische Expertise, damit Betriebe und Menschen souveräner im Einsatz von modernen Technologien werden - mit neuen Formen von Technologiebildung und Prototyping.</p>
        </div>
        
        <div className="founders-grid">
          <div className="founder-card">
            <div className="founder-image">
              <img 
                src="/assets/images/home/founders/wilhelm.jpg" 
                alt="Wilhelm Klat" 
                className="founder-photo"
                onDragStart={handleDragStart}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxjaXJjbGUgY3g9IjEwMCIgY3k9IjgwIiByPSIzMCIgZmlsbD0iIzJjM2U1MCIvPgo8cGF0aCBkPSJNNTAgMTUwQzUwIDEyNS44IDY5LjggMTA2IDk0IDEwNkgxMDZDMTMwLjIgMTA2IDE1MCAxMjUuOCAxNTAgMTUwVjE2MEg1MFYxNTBaIiBmaWxsPSIjMmMzZTUwIi8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTg1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNjY3ZWVhIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTIiPldpbGhlbG08L3RleHQ+Cjwvc3ZnPg==`;
                  target.alt = 'Wilhelm Klat - Placeholder';
                }}
              />
            </div>
            <div className="founder-info">
              <h3>Wilhelm Klat <span className="degree">(M. Sc.)</span></h3>
              <h4>Technische Leitung</h4>
              <p>Mit mehr als 12 Jahren Erfahrung in der industriellen KI-Automation entwickelt er passgenaue KI-Lösungen für den betrieblichen Alltag. Darüber hinaus unterstützt er Betriebe dabei, sinnvolle erste Schritte bei der Entwicklung und dem Einsatz von KI-Lösungen zu gehen.</p>
            </div>
            <div className="founder-links">
              <a 
                href="https://www.linkedin.com/in/wilhelm-klat/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link linkedin-link"
                onDragStart={handleDragStart}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a 
                href="https://scholar.google.com/citations?hl=en&user=c28CkzQAAAAJ" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link scholar-link"
                onDragStart={handleDragStart}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8.5 1H15.5V7L20 21C20.3 21.8 19.7 22.5 18.5 22.5H5.5C4.3 22.5 3.7 21.8 4 21L8.5 7V1Z"/>
                  <path d="M8 1H16V2.5H8V1Z"/>
                  <path d="M15.5 1.2H16.5V2.8H15.5V1.2Z"/>
                  <circle cx="9" cy="15" r="1.2"/>
                  <circle cx="15" cy="18" r="1"/>
                  <circle cx="12" cy="12" r="1.5"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="founder-card">
            <div className="founder-image">
              <img 
                src="/assets/images/home/founders/antonia.jpeg" 
                alt="Antonia Schulte" 
                className="founder-photo"
                onDragStart={handleDragStart}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxjaXJjbGUgY3g9IjEwMCIgY3k9IjgwIiByPSIzMCIgZmlsbD0iIzAwOEY5OSIvPgo8cGF0aCBkPSJNNTAgMTUwQzUwIDEyNS44IDY5LjggMTA2IDk0IDEwNkgxMDZDMTMwLjIgMTA2IDE1MCAxMjUuOCAxNTAgMTUwVjE2MEg1MFYxNTBaIiBmaWxsPSIjMDA4Rjk5Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTg1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNjY3ZWVhIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTIiPkFudG9uaWE8L3RleHQ+Cjwvc3ZnPg==`;
                  target.alt = 'Antonia Schulte - Placeholder';
                }}
              />
            </div>
            <div className="founder-info">
              <h3>Antonia Schulte <span className="degree">(M. Ed.)</span></h3>
              <h4>Didaktische Leitung</h4>
              <p>Als ausgebildete Lehrerin und Expertin für Technologiebildung entwickelt sie neuartige Konzepte für die berufliche Aus- und Weiterbildung. In der MINTkitchen ist sie für die didaktische Leitung zuständig.</p>
            </div>
            <div className="founder-links">
              <a 
                href="https://www.linkedin.com/in/antonia-schulte/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link linkedin-link"
                onDragStart={handleDragStart}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a 
                href="https://scholar.google.com/citations?user=a_vkRagAAAAJ&hl=de" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link scholar-link"
                onDragStart={handleDragStart}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8.5 1H15.5V7L20 21C20.3 21.8 19.7 22.5 18.5 22.5H5.5C4.3 22.5 3.7 21.8 4 21L8.5 7V1Z"/>
                  <path d="M8 1H16V2.5H8V1Z"/>
                  <path d="M15.5 1.2H16.5V2.8H15.5V1.2Z"/>
                  <circle cx="9" cy="15" r="1.2"/>
                  <circle cx="15" cy="18" r="1"/>
                  <circle cx="12" cy="12" r="1.5"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
